<script setup lang="ts">
import BaseForm from "~/components/ui/BaseForm.vue";
import ProgressBar from "~/components/ui/ProgressBar.vue";
import FormCard from "~/components/ui/FormCard.vue";
const locale = await getLocale("forms", "club_warning", "it", true);

defineComponent({
  name: "ClubWarning",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
});

const emit = defineEmits(["init", "submit", "decline"]);

onMounted(() => emit("init"));

</script>

<template>

  <BaseForm>

    <template #upper>

      <ProgressBar :value="progress" />

      <FormCard :title="title" @submit="emit('submit')">

        <div class="w-full grid grid-col-1 md:grid-cols-12 gap-4">

          <div class="md:col-span-8 md:py-4 -mt-2  flex flex-col justify-between" v-html="locale.description"></div>
          
          <div class="md:col-span-4 flex justify-end my-3 md:mt-0">
            <div class="w-full flex md:flex-col justify-start md:justify-center items-center gap-4 border rounded-xl p-3 md:p-5 md:max-w-[200px]">
                <div class="flex w-fit justify-center pl-2">
                    <img src="/public/images/static/EPdA-Logo-2025_rgb.png" class="md:h-24 w-20 md:w-auto block" alt="logo prodotto dell'anno">
                    <span class="ml-1">*</span>
                </div>
                <div class="-mt-1 md:mt-0 text-base md:text-sm md:text-center" v-html="locale.description2"></div>
            </div>
          </div>
          
        </div>

        <template #link>
          <div class="text-center text-gray-700 mt-4 mb-8">
            <button data-testid="decline" class="underline" type="button" @click="emit('decline')">
              {{ locale.proceed_without_club }}
            </button>
          </div>
        </template>

      </FormCard>

    </template>

    <template #bottom-out>

      <p class="italic px-4 text-sm md:text-base">{{ locale.disclaimer }}</p>

    </template>

  </BaseForm>

</template>

<style scoped>
/* @media screen and (max-width: 639px) {
  div :deep(.form-header) {
    font-size: 1rem !important;
  }
} */
</style>
